import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _168b6cb3 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _521bf555 = () => interopDefault(import('../pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _6048cfab = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _52994ff9 = () => interopDefault(import('../pages/help/_category.vue' /* webpackChunkName: "pages/help/_category" */))
const _60bef786 = () => interopDefault(import('../pages/help/_category/_article.vue' /* webpackChunkName: "pages/help/_category/_article" */))
const _bb1ec17a = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _3d268e12 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _ad8c7074 = () => interopDefault(import('../pages/account/addresses.vue' /* webpackChunkName: "pages/account/addresses" */))
const _3f09bd34 = () => interopDefault(import('../pages/account/details.vue' /* webpackChunkName: "pages/account/details" */))
const _e3328d14 = () => interopDefault(import('../pages/account/favourites.vue' /* webpackChunkName: "pages/account/favourites" */))
const _63bd260d = () => interopDefault(import('../pages/account/login.vue' /* webpackChunkName: "pages/account/login" */))
const _a658681e = () => interopDefault(import('../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _34734da7 = () => interopDefault(import('../pages/checkout/payment.vue' /* webpackChunkName: "pages/checkout/payment" */))
const _04a6e165 = () => interopDefault(import('../pages/newsletter/unsubscribe.vue' /* webpackChunkName: "pages/newsletter/unsubscribe" */))
const _4b7e4605 = () => interopDefault(import('../pages/checkout/success/_orderId.vue' /* webpackChunkName: "pages/checkout/success/_orderId" */))
const _0d21eea8 = () => interopDefault(import('../pages/newsletter/manage/_id.vue' /* webpackChunkName: "pages/newsletter/manage/_id" */))
const _565cf77e = () => interopDefault(import('../pages/categories/_slug.vue' /* webpackChunkName: "pages/categories/_slug" */))
const _6fdb1a05 = () => interopDefault(import('../pages/pages/_slug.vue' /* webpackChunkName: "pages/pages/_slug" */))
const _21024c74 = () => interopDefault(import('../pages/products/_id/_slug.vue' /* webpackChunkName: "pages/products/_id/_slug" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f6ee20da = () => interopDefault(import('../pages/_slug/index.vue' /* webpackChunkName: "pages/_slug/index" */))
const _2efaf336 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _168b6cb3,
    name: "checkout"
  }, {
    path: "/contact-us",
    component: _521bf555,
    name: "contact-us"
  }, {
    path: "/help",
    component: _6048cfab,
    name: "help",
    children: [{
      path: ":category?",
      component: _52994ff9,
      name: "help-category",
      children: [{
        path: ":article?",
        component: _60bef786,
        name: "help-category-article"
      }]
    }]
  }, {
    path: "/reset-password",
    component: _bb1ec17a,
    name: "reset-password"
  }, {
    path: "/search",
    component: _3d268e12,
    name: "search"
  }, {
    path: "/account/addresses",
    component: _ad8c7074,
    name: "account-addresses"
  }, {
    path: "/account/details",
    component: _3f09bd34,
    name: "account-details"
  }, {
    path: "/account/favourites",
    component: _e3328d14,
    name: "account-favourites"
  }, {
    path: "/account/login",
    component: _63bd260d,
    name: "account-login"
  }, {
    path: "/account/orders",
    component: _a658681e,
    name: "account-orders"
  }, {
    path: "/checkout/payment",
    component: _34734da7,
    name: "checkout-payment"
  }, {
    path: "/newsletter/unsubscribe",
    component: _04a6e165,
    name: "newsletter-unsubscribe"
  }, {
    path: "/checkout/success/:orderId?",
    component: _4b7e4605,
    name: "checkout-success-orderId"
  }, {
    path: "/newsletter/manage/:id?",
    component: _0d21eea8,
    name: "newsletter-manage-id"
  }, {
    path: "/categories/:slug?",
    component: _565cf77e,
    name: "categories-slug"
  }, {
    path: "/pages/:slug?",
    component: _6fdb1a05,
    name: "pages-slug"
  }, {
    path: "/products/:id?/:slug?",
    component: _21024c74,
    name: "products-id-slug"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/:slug",
    component: _f6ee20da,
    name: "slug"
  }, {
    path: "/*",
    component: _2efaf336,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
